module.exports = "<app-payor-date-range-report reportPath=\"CreateZuniReport\" isDateRange=\"true\" isExcel=\"true\" title=\"AMR Report\" reportName=\"AMR Report\" payorDropdown=\"true\" > </app-payor-date-range-report>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/manager-reports/zuni-report/zuni-report.component.html
// module id = 2471
// module chunks = 66